import React, {useCallback} from 'react';
import {Button, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {automationMenuRef} from '../../constants';
import {texts} from '../../../../texts';
import {ModernTooltip} from '../../../../../../components/Common/Tooltip/ModernTooltip';

export const ButtonTrigger = ({isOpen, onClick, disabled, buttonComponentClasses = ''}) => {
    const [isShowTooltip, setIsShowTooltip] = React.useState(false);

    const handleToggleShow = useCallback(
        (flag: boolean) => {
            if (isOpen) {
                setIsShowTooltip(false);
            } else {
                setIsShowTooltip(flag);
            }
        },
        [isOpen]
    );

    return (
        <ModernTooltip
            tooltip={texts.menu_trigger}
            maxWidth={160}
            position="bottom"
            show={isShowTooltip}
            toggleShow={handleToggleShow}
        >
            <Button
                componentClasses={buttonComponentClasses}
                inputRef={automationMenuRef}
                skin="text"
                onClick={onClick}
                prefixIcon={PriorityIcon.automations}
                suffixIcon={<Icon icon={PriorityIcon.arrowDropDown} />}
                disabled={disabled}
            >
                <span>{texts.menu_trigger}</span>
            </Button>
        </ModernTooltip>
    );
};
